<div>
  <h2 mat-dialog-title>Record Details</h2>
  <div class="nav">
    <div>
      <b>Last Updated: </b>{{ dt.updatedAt | date: 'short' }}
    </div>
    <div>
      <button mat-button (click)="onDelete()">Delete</button>
      <button mat-button (click)="onNext(-1)">Back</button>
      <button mat-button #nextBtn (click)="onNext(1)" cdkFocusInitial>Next</button>
    </div>
  </div> 
</div>

<mat-grid-list cols="2" rowHeight="20px">
  <mat-grid-tile colspan="2" rowspan="17">
    <app-record-detail [data]="dt" (changes)="onChange($event)" (update)="onUpdate($event)"></app-record-detail>
  </mat-grid-tile>
  <mat-grid-tile rowspan="16">
    <app-note [profile]="dt.NoteProfile" [inputForm]="dt.UserData.Note" (changes)="onNoteChange($event)"></app-note>
  </mat-grid-tile>
  <mat-grid-tile rowspan="16">
    <app-search-matches [matches]="dt.SearchMatches"></app-search-matches>
  </mat-grid-tile>
  <mat-grid-tile rowspan="16">
    <app-search-matches [matches]="dt.Satisfactions"></app-search-matches>
  </mat-grid-tile>
</mat-grid-list>

<div class="footer">
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="data.data">Close</button>
  </mat-dialog-actions>
</div>
